import * as React from 'react';
import { Popup } from 'rc-tooltip';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import useStyle from './style';
// ant-tooltip css-dev-only-do-not-override-w2s56n ant-tooltip-placement-top  ant-tooltip-hidden
export default function PurePanel(props) {
    const { prefixCls: customizePrefixCls, className, placement = 'top', title } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const [wrapSSR, hashId] = useStyle(prefixCls, true);
    return wrapSSR(React.createElement("div", { className: classNames(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className) },
        React.createElement(Popup, Object.assign({}, props, { className: hashId, prefixCls: prefixCls }), title)));
}
